import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Group } from '../../models/group.model';
import { Session, SessionStatus } from '../../models/session.school.model';

export const getSessions = createAction(
  '[School Session] Get Sessions',
  props<{
    groupId: string;
    academicYear: number;
    gradeId?: string;
    teacherId?: string;
    fromDate?: Timestamp;
    status?: SessionStatus[];
    lastRecord?: Timestamp;
  }>(),
);

export const addSessionsToStore = createAction(
  '[School Session] Add Sessions to store',
  props<{ sessions: Session[] }>(),
);
export const addSessionToStore = createAction(
  '[School Session] Add Session to store',
  props<{ session: Session }>(),
);

export const getSession = createAction(
  '[School Session] Get session',
  props<{ sessionId: string }>(),
);

export const getSessionsFailure = createAction(
  '[School Session] Get Sessions Failed',
  props<{ error: AppExceptionModel }>(),
);

// Create Session Actions
export const create = createAction(
  '[School Session] Create',
  props<{ groupId: string; session: Session }>(),
);
export const createFailure = createAction(
  '[School Session] Create Failure',
  props<{ error: AppExceptionModel }>(),
);
export const createSuccess = createAction(
  '[School Session] Create Success',
  props<{ session: Session }>(),
);

// Update Session Actions
export const update = createAction(
  '[School Session] Update',
  props<{ groupId: string; sessionId: string; session: Session }>(),
);
export const updateFailure = createAction(
  '[School Session] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Session] Update Success',
  props<{ session: Session }>(),
);

// Update Session Status
export const updateStatus = createAction(
  '[School Session] Update Status',
  props<{ groupId: string; sessionId: string; session: Session }>(),
);
export const updateStatusFailure = createAction(
  '[School Session] Update Status Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateStatusSuccess = createAction(
  '[School Session] Update Status Success',
  props<{ session: Session }>(),
);

// Delete Session Actions
export const deleteAction = createAction(
  '[School Session] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[School Session] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Session] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Session] Clear from store',
  props<{ id: string }>(),
);

export const getSessionStats = createAction(
  '[School Session] Get Grade Session Statistics',
  props<{ groupId: string; gradeId: string; gradeYear: number }>(),
);

export const loadSessionStats = createAction(
  '[School Session] Load Session Stats',
  props<{ groupId: string }>(),
);

export const getSessionStatsDone = createAction(
  '[School Session] Get Session Statistics Done',
  props<{ group: Group }>(),
);

export const getSessionStatsFailure = createAction(
  '[School Session] Session Statistics Failure',
  props<{ error: any }>(),
);

export const clear = createAction('[School Session] Clear Sessions');

export const clearFromStore = createAction(
  '[School Session] Clear multiple from store',
  props<{ ids: string[] }>(),
);

// export const clearByAcademicYear = createAction(
//   '[School Session] Clear Sessions By Academic Year',
//   props<{ groupId: string; academicYear: number }>()
// );
